import { MsalProvider } from '@azure/msal-react';
import { Loading } from '@components/loading';
import NetworkError from '@components/networkError';
import { psa } from '@services/aad';
import { apiInterceptor } from '@services/api';

import React from 'react';
import { BrowserRouter } from 'react-router';
import Routes from './Routes';
import '@style/main.scss';

export const App = () => {
  const [networkError, setNetworkError] = React.useState<Error | undefined>();

  const handleNetworkSuccess = React.useCallback(() => {
    if (networkError) {
      setNetworkError(undefined);
      window.dispatchEvent(new Event('networkRestored'));
    }
  }, [networkError, setNetworkError]);

  const handleNetworkError = React.useCallback(
    (err: Error) => {
      setNetworkError(err.message === 'Network Error' ? err : undefined);
      window.dispatchEvent(new Event('networkError'));
    },
    [setNetworkError],
  );

  React.useEffect(
    () => apiInterceptor(handleNetworkSuccess, handleNetworkError),
    [handleNetworkSuccess, handleNetworkError],
  );

  return (
    <React.Suspense fallback={<Loading />}>
      <MsalProvider instance={psa()}>
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
        {networkError && <NetworkError />}
      </MsalProvider>
    </React.Suspense>
  );
};
